import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_vm.isSepa ? _c("div", {
    staticClass: "container-centered small-2"
  }, [_c("form", [_c("div", {
    staticClass: "bank-label"
  }, [_vm._v("IBAN")]), _c("div", {
    attrs: {
      id: "bank-account-element"
    }
  }), _vm.errorMessage ? _c("div", {
    staticClass: "errorLabel",
    attrs: {
      role: "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e()]), _c("div", {
    staticClass: "btn-save"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.isValid
    },
    on: {
      click: function click($event) {
        return _vm.saveBankAccount();
      },
      shortkey: function shortkey($event) {
        return _vm.saveBankAccount();
      }
    }
  }, [_vm._v(" Save ")])], 1), _c(VDivider, {
    staticClass: "divider"
  })], 1) : _vm.isAch ? _c("div", {
    staticClass: "container-centered small-2"
  }, [_c(VBtn, {
    staticClass: "connect-button ach-button",
    attrs: {
      loading: _vm.isConnectingAch
    },
    on: {
      click: _vm.connectAch
    }
  }, [_vm._v(" Connect a new bank account ")]), _c("div", {
    staticClass: "mandate-acceptance"
  }, [_vm._v(" If you use " + _vm._s(_vm.$whitelabel.legalName) + "’ services or purchase additional products periodically pursuant to " + _vm._s(_vm.$whitelabel.legalName) + "’ terms, you authorize " + _vm._s(_vm.$whitelabel.legalName) + " to debit your bank account periodically. Payments that fall outside of the regular debits authorized above will only be debited after your authorization is obtained. ")]), _c(VDivider, {
    staticClass: "divider"
  })], 1) : _vm._e(), _vm.list.length > 0 ? [_c("div", {
    staticClass: "mb-4"
  }, [_vm._v("Saved bank accounts")])] : _vm._e(), _c("section", {
    staticClass: "container-payments"
  }, [_vm.isLoading ? _c(VSkeletonLoader, {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "image"
    }
  }) : _vm.list.length === 0 ? [_c("div", [_vm._v("No bank account saved")])] : _vm.list.length > 0 ? _vm._l(_vm.list, function (ba) {
    return _c("div", {
      key: ba.id_stripe_bank_account,
      staticClass: "card-payment"
    }, [_c("div", {
      staticClass: "card"
    }, [_c("div", {
      staticClass: "card__front card__part"
    }, [_c("div", {
      staticClass: "card_brand"
    }, [_c("p", {
      staticClass: "card_brand_title"
    }, [_c("i", {
      staticClass: "fas fa-landmark"
    }), _vm._v(" " + _vm._s(_vm.isSepa ? "iban" : "ach") + " ")]), _c("div", {
      staticClass: "btn-delete",
      attrs: {
        title: _vm.numberOfPaymentMethods > 1 && ba.default ? "Please set an other default payment method to be allowed to delete it" : ""
      }
    }, [_c(VBtn, {
      attrs: {
        rounded: "",
        disabled: _vm.numberOfPaymentMethods > 1 && ba.default
      },
      on: {
        click: function click($event) {
          return _vm.deleteBankAccount(ba.payment_method_id);
        },
        shortkey: function shortkey($event) {
          return _vm.deleteBankAccount(ba.payment_method_id);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        small: "",
        dark: ""
      }
    }, [_vm._v("mdi-delete")])], 1)], 1)]), _c("p", {
      staticClass: "card_number"
    }, [_vm._v(" " + _vm._s(ba.country || ba.routing_number) + "**" + _vm._s(ba.bank_name) + "******" + _vm._s(ba.last4) + " ")]), _c("div", {
      staticClass: "card__footer"
    })])]), _vm.numberOfPaymentMethods > 1 && !ba.default ? _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.setDefaultPayment(ba);
        }
      }
    }, [_vm._v(" Set as default payment ")]) : _vm._e()], 1);
  }) : _vm._e()], 2), _c("confirm", {
    ref: "confirm"
  }), _c("MicroDepositsDialog", {
    attrs: {
      linkUrl: _vm.microDepositsUrl
    },
    on: {
      continue: _vm.continueSaveFromDeposits
    },
    model: {
      value: _vm.microDepositsShown,
      callback: function callback($$v) {
        _vm.microDepositsShown = $$v;
      },
      expression: "microDepositsShown"
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };